import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Table, Row } from "reactstrap";
import { H3, H5, H6, Image, P } from "../../../AbstractElements";
import { onlinePayments } from "../../../Constant";
import HeaderCard from "../../Common/Component/HeaderCard";
import { Link } from 'react-router-dom';

const ActivityReview = (connections) => {
    const count = connections.connections.connections;
    const SalesData = [
        {
            id: 1,
            icon: 'icofont icofont-arrow-down font-primary',
            iconClass: 'bg-light-primary',
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/report/payment-collection?day=today`}>
                {'Today'}
            </Link>,
            title: 'Today',
            class: 'font-primary',
            count: count.today
        },
        {
            id: 2,
            icon: 'icofont icofont-arrow-down font-secondary',
            iconClass: 'bg-light-secondary',
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/report/payment-collection?day=this_month`}>
                {' This Month'}
            </Link>,
            class: 'font-secondary',
            count: count.this_month
        },
    ]
    return (
        <Fragment>
            <Col xl="3" className="box-col-3">
                <Card className="widget-joins widget-arrow">
                    {/* <HeaderCard title={onlinePayments} setting={true} /> */}
                    <HeaderCard
                        title={<span className="header-card-title">{onlinePayments}</span>}
                        setting={true}
                    />
                    <CardBody>
                        {SalesData.map((data,indx) => {
                            return (
                                <Col sm="12" key={indx}>
                                    <div className="widget-card" style={{ padding: '8px', marginBottom: '3px' }}>
                                        <div className="d-flex align-self-center">
                                            <div className={`widget-icon ${data.iconClass}`}>
                                                <i className={`${data.icon}`}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <H6>{data.title}</H6>
                                                <H5>
                                                    <span className="counter">{data.count}</span>
                                                    <span className={`${data.class}`}>{data.numbers}</span>
                                                </H5>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                            )
                        })}
                        {/* </Row> */}
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}
export default ActivityReview;